var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "gs-wrap" }, [
    _c(
      "div",
      { staticClass: "gs-scope-wrap" },
      [
        _c("global-dropdown", {
          attrs: {
            id: "global-search-scope",
            value: _vm.assetType,
            options: _vm.scopeOptions,
            size: 32,
            "min-width": 125,
            "panel-class": "gs-scope-panel",
            "full-width": ""
          },
          on: { input: _vm.selectScope }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "gs-search-box" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.assetName,
            expression: "assetName"
          }
        ],
        ref: "searchInput",
        attrs: { placeholder: "Search for asset(s) by name" },
        domProps: { value: _vm.assetName },
        on: {
          keydown: [
            function($event) {
              return _vm.nameKeydown($event)
            },
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.performSearch($event)
            }
          ],
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.assetName = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c(
        "svg",
        {
          staticClass: "gs-search-icon",
          attrs: {
            width: "13",
            height: "13",
            viewBox: "0 0 16 16",
            role: "button",
            "aria-label": "Search",
            tabindex: "0"
          },
          on: {
            click: function($event) {
              _vm.assetName && _vm.assetName.length >= 1
                ? _vm.performSearch()
                : _vm.$refs.searchInput.focus()
            },
            keydown: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              _vm.assetName && _vm.assetName.length >= 1
                ? _vm.performSearch()
                : _vm.$refs.searchInput.focus()
            }
          }
        },
        [
          _c("path", {
            attrs: {
              d:
                "M6.5 1a5.5 5.5 0 104.22 9.03l3.12 3.12.71-.71L11.44 9.2A5.5 5.5 0 006.5 1zm0 1a4.5 4.5 0 110 9 4.5 4.5 0 010-9z"
            }
          })
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }